import styled from 'styled-components';

import { Column } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 30%;
`;

const UrlColumn = styled(Column)`
  width: 40%;
`;

const ActionColumn = styled(Column)`
  width: 30%;
`;

export {
  ActionColumn,
  NameColumn,
  UrlColumn,
};
